// Reference:
// * https://github.com/shadcn-ui/ui/blob/7f0af435e14e2e1121f855d5762a3659ef0b51e6/apps/www/lib/utils.ts

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Manage Tailwind CSS class names by combining "clsx" and "twMerge":
// * "clsx" handles the conditional logic and generation of class names.
// * "twMerge" resolves potential conflicts in Tailwind CSS classes.
//
// This simplifies class name management, as demonstrated below:
// ```
// <button
//   className={cn(
// 	   "px-4 py-2 font-bold text-white",
// 	   primary ? "bg-blue-500" : "bg-gray-500",
// 	   className
//   )}
// >
// ```
//
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
